import { render, staticRenderFns } from "./Lgx178615594902355968.vue?vue&type=template&id=663cd599&scoped=true&"
import script from "./Lgx178615594902355968.vue?vue&type=script&lang=js&"
export * from "./Lgx178615594902355968.vue?vue&type=script&lang=js&"
import style0 from "./Lgx178615594902355968.vue?vue&type=style&index=0&id=663cd599&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663cd599",
  null
  
)

export default component.exports